export default __webpack_public_path__ + "static/media/applemusic.ed81d656.svg";